package nl.volleyplanner.nevoboservice.api

data class PathTemplateNode(
    val nodeName: String,
    val isField: Boolean
)

object NevoboPathResolver {
    fun getPathTemplateNodes(template: String): List<PathTemplateNode> {
        // TODO: Likely we can just parse the path with regex. Leaving this for now coming from a more
        //  sophisticated JVM solution
        return template.split("/")
            .mapTo(mutableListOf()) { rawNode ->
                if (rawNode.startsWith("{") && rawNode.endsWith("}")) {
                    val nodeName = rawNode.substring(1, rawNode.length - 1)
                    PathTemplateNode(nodeName, true)
                } else {
                    PathTemplateNode(rawNode, false)
                }
            }
    }

    fun getPathVariables(template: String, path: String) : Map<String, String> {
        val pathTemplateNodes = getPathTemplateNodes(template)

        val pathParts = path.split("/")

        require(pathTemplateNodes.size == pathParts.size) { "Path $path does not match template $template" }

        return mapOf(
            *pathTemplateNodes.mapIndexedNotNull { index, pathTemplateNode ->
                val pathPart = pathParts[index]

                if (pathTemplateNode.isField) {
                    Pair(pathTemplateNode.nodeName, pathPart)
                } else {
                    require(pathTemplateNode.nodeName == pathPart) { "Path $path does not match template $template" }
                    null
                }
            }.toTypedArray()
        )
    }
}